import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
const NewHome = () => {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);


    return (
        <div className="container_new content_page" style={{ marginTop: 100 }}>
            {/* About Us Section */}
            <section className="about-section" id="about-us">
                <div className="container">
                    {/* Header */}
                    <header className="about-header">
                        <h2 className="content_heading">About Us</h2>
                        {/* <p className="about-subtitle"> */}
                        <p className="highlight">
                            Paybacck™ is the decision intelligence platform for digital investments.
                        </p>
                    </header>

                    {/* Problem */}
                    <div className="about-block">
                        <p className="lead">
                            Paybacck was created to solve one of the most expensive and least discussed problems in modern business: <strong>why digital initiatives fail—even when they are well executed.</strong>
                        </p>

                        {/* <div className="stat-callout">
                            <span className="stat-number">70–90%</span>
                            <span className="stat-text">
                                of digital initiatives fail or fall far short of expectations
                            </span>
                        </div> */}

                        <p>
                            Across industries, organizations invest millions (sometimes billions) in digital transformation, innovation, and new products. Yet year after year, <strong>70–90% of these initiatives fail or fall far short of expectations,</strong> costing corporate America hundreds of billions of dollars annually. The reason is not a lack of talent, effort, or technology—it is the absence of a formal framework to manage the <strong>“why” and “what”</strong> of digital investments before execution begins.
                        </p>
                    </div>

                    {/* Solution */}
                    <div className="about-block">
                        <h3>Paybacck exists to close that gap.</h3>
                        <p>
                            Unlike traditional tools that focus on delivery mechanics—Agile, DevOps, project management, or engineering velocity—Paybacck addresses the <strong>foundational decisions</strong> that determine success or failure long before code is written. Our platform enables leaders to evaluate ideas, products, transformations, and investments with clarity, precision, and confidence.
                        </p>
                    </div>

                    {/* Framework */}
                    <div className="about-block">
                        {/* <h3>A Proven Decision Framework</h3> */}
                        <p>
                            At the core of Paybacck is a <strong>proven decision framework composed of 16 integrated tools,</strong> each designed to answer a critical business question:
                        </p>

                        <div className="question-grid">
                            <div className="question-card">Is this problem worth solving?</div>
                            <div className="question-card">Will customers actually adopt this?</div>
                            <div className="question-card">Is the revenue real — or assumed?</div>
                            <div className="question-card">Do we have the right positioning and timing?</div>
                            <div className="question-card">Are risks, funding, and execution aligned?</div>
                        </div>
                    </div>

                    {/* How it Works */}
                    <div className="about-block">
                        <p>
                            Paybacck does not rely on opinions or intuition alone. It combines structured thinking, research-driven scorecards, and a proprietary interpretation engine to deliver <strong>clear go / no-go recommendations</strong>, highlight weaknesses, and expose deal-killers early—before capital, time, and credibility are lost.
                        </p>
                    </div>

                    {/* Audience */}
                    <div className="about-block">
                        <p>Today, Paybacck is used by <strong>founders, CEOs, executive leaders, product owners, and investors</strong> across industries to:</p>
                    </div>

                    {/* Outcomes */}
                    <div className="about-block about-outcomes">
                        {/* <h3>What Teams Achieve</h3> */}
                        <ul className="outcome-list">
                            <li>Avoid bad digital investments</li>
                            <li>Prioritize initiatives with the highest return potential</li>
                            <li>Reduce complexity and wasted effort</li>
                            <li>Design products customers actually want</li>
                            <li>Confidently fund and execute innovation</li>
                        </ul>
                    </div>

                    {/* Closing */}
                    <footer className="about-footer">
                        <p className="closing-statement">
                            Paybacck is not just a platform—it is a <strong>new standard for digital decision-making.</strong> It is how organizations move from hope-driven innovation to <strong>outcome-driven success.</strong>
                        </p>
                    </footer>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section" id="how-it-works">
                <div className="container">
                    {/* Header */}
                    <header className="how-header">
                        <h2 className="content_heading">How It Works</h2>
                        <p className="how-subtitle bold-lines">
                            Paybacck works by making the invisible visible — before you commit.
                        </p>
                    </header>

                    {/* Intro */}
                    <div className="how-intro">
                        <p className="bold-lines">
                            Most digital failures do not happen because of poor execution. They happen because the <strong>wrong problems are solved,</strong> the <strong></strong>wrong assumptions are made, or critical misalignments go unnoticed until it’s too late. Paybacck systematically eliminates those blind spots.
                        </p>

                        <p>
                            The Paybacck process is structured, repeatable, and adaptable to <strong>any industry, company size, or digital initiative.</strong>
                        </p>
                    </div>

                    {/* Steps */}
                    <div className="steps-wrapper">
                        <div className="step-card">
                            <div className="step-number">01</div>
                            <h3>Define the Opportunity Clearly</h3>
                            <p>
                                Every engagement begins by applying Paybacck’s foundational problem-definition tools. These frameworks ensure that the problem you are solving is real, meaningful, and worth solving—eliminating vague objectives and misaligned expectations early.
                            </p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">02</div>
                            <h3>Apply the Paybacck Scorecards</h3>
                            <p>
                                Each Paybacck tool includes a practical scorecard. You apply these scorecards to your idea, product, or transformation by conducting focused research, stakeholder alignment, and customer validation. The process is structured but flexible—you refine inputs as insights improve.
                            </p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">03</div>
                            <h3>Connect the Dots Across Critical Domains</h3>
                            <p>
                                Unlike siloed evaluations, Paybacck integrates <strong>market demand, buyer motivation, competitive dynamics, revenue potential, risk, funding, marketing readiness, timing, and execution feasibility</strong> into a single decision framework. This “connect-the-dots” approach is what makes Paybacck fundamentally different.
                            </p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">04</div>
                            <h3>Get a Go / No-Go Recommendation</h3>
                            <p>Once scorecards are completed, Paybacck’s interpretation engine generates:</p>
                            <ul>
                                <li>A clear go / no-go recommendation</li>
                                <li>Explicit identification of weak areas</li>
                                <li>Identification of deal-killers, if any</li>
                                <li>Actionable guidance on how to improve viability</li>
                            </ul>
                        </div>

                        <div className="step-card">
                            <div className="step-number">05</div>
                            <h3>Act with Confidence</h3>
                            <p>With Paybacck, leaders can confidently:</p>
                            <ul>
                                <li>Greenlight high-potential initiatives</li>
                                <li>Kill weak ideas early (before losses compound)</li>
                                <li>Pivot existing products for growth</li>
                                <li>Prioritize roadmaps and funding intelligently</li>
                                <li>Align teams around a shared rationale</li>
                            </ul>
                        </div>
                    </div>

                    {/* Closing */}
                    <div className="how-closing">
                        <p>
                            Paybacck puts organizations <strong>years ahead of the market,</strong> replacing guesswork with structured clarity and enabling faster, smarter decisions—without slowing innovation.
                        </p>
                    </div>
                </div>
            </section>

            {/* Features Section */}

            <section className="engage-section" id="how-we-engage">
                <div className="container">
                    {/* How We Engage */}
                    <header className="engage-header">
                        <h2 className="content_heading">How We Engage</h2>
                    </header>

                    <div className="engage-grid">
                        <div className="engage-card">
                            <h3>Consulting</h3>
                            <p>
                                For urgent or high-stakes situations, our experts work directly with your team to rapidly evaluate initiatives, uncover risks, and provide clear recommendations.
                            </p>
                        </div>

                        <div className="engage-card">
                            <h3>Corporate Training & Workshops</h3>
                            <p>
                                For long-term impact, we train your teams to embed Paybacck into your organization—building internal capability for consistent digital success.
                            </p>
                        </div>

                        <div className="engage-card">
                            <h3>Self-Service Platform</h3>
                            <p>
                                For hands-on leaders, Paybacck’s online tools and video tutorials allow you to start immediately and move at your own pace.
                            </p>
                        </div>
                    </div>

                    {/* Get Started */}
                    <div className="get-started-section" id="get-started">
                        <h2 className="content_heading">Get Started</h2>

                        <p className="get-started-lead">
                            We offer a <strong>free initial consultation</strong> to understand your goals and determine how Paybacck can help you avoid costly mistakes and unlock high-value opportunities.
                        </p>

                        <div className="contact-grid">
                            <div>
                                <strong>Office</strong>
                                <p>
                                    5700 Tennyson Parkway, Suite 300<br />
                                    Plano, TX 75024, USA
                                </p>
                            </div>

                            <div>
                                <strong>Email</strong>
                                <p>
                                    <a href="mailto:info@paybacck.com">info@paybacck.com</a>
                                </p>
                            </div>
                        </div>

                        <p className="closing-line">
                            Your digital investments deserve more than hope.
                            <br />
                            <strong>Make your next decision your strongest one.</strong>
                        </p>
                    </div>
                </div>
            </section>



            {/* Features and Services Section */}

            <section className="features-section" id="features">
                <div className="container">
                    {/* Header */}
                    <header className="features-header">
                        <h2 className="content_heading">Features</h2>
                        <h3 className="subheading">Framework, not guesswork.</h3>
                    </header>

                    {/* Intro */}
                    <div className="features-intro">
                        <p>
                            Paybacck’s features are built around one purpose: helping you make <strong>better digital investment decisions in less time.</strong> Instead of yet another project-tracking tool, Paybacck is a <strong>decision framework</strong> that operates <strong>before and alongside delivery tools</strong> like Agile, DevOps, and project management platforms.
                        </p>
                    </div>

                    {/* Feature List */}
                    <div className="features-grid">
                        <div className="feature-card">
                            <h4>8-Dimensional Problem Definition</h4>
                            <p>
                                Clarify whether a problem is worth solving. Our structured lens forces you to examine customers, stakeholders, urgency, alternatives, constraints, and potential impact—eliminating vague problem statements and hidden disagreement from day one.
                            </p>
                        </div>

                        <div className="feature-card">
                            <h4>Buyer Motivation & Decision Alignment</h4>
                            <p>
                                Paybacck’s <strong>Buyer Motivation Parity</strong> and <strong>Purchase Decision Alignment</strong> tools reveal if customers actually care enough to take action, pay, and switch. You’ll understand time-to-revenue, adoption hurdles, and what really drives a purchase.
                            </p>
                        </div>

                        <div className="feature-card">
                            <h4>Solution & Risk Scorecards</h4>
                            <p>
                                Evaluate whether your solution is buildable, differentiated, and viable. Our <strong>Solution Scorecard, Risk Score,</strong> and <strong>Funding Score</strong> expose feasibility gaps, under-estimated effort, and under-funded ambitions—while there’s still time to adjust.
                            </p>
                        </div>

                        <div className="feature-card">
                            <h4>Competitive & Market Positioning</h4>
                            <p>
                                Use <strong>Crux Rectangle, Crux Competitive, Crux Impact,</strong> and <strong>Crux Alignment</strong> to understand your true competitive edge, customer appeal, and inherent product strength—so you don’t launch “just another app” into a crowded space.
                            </p>
                        </div>

                        <div className="feature-card">
                            <h4>Revenue, Marketing & Channel Fit</h4>
                            <p>
                                Paybacck’s <strong>Revenue Score, Marketing Score,</strong> and <strong>Product Market Channel Model (PMCM)</strong> tools connect your idea to real revenue logic: who you reach, how you reach them, and whether your marketing capabilities can actually support the strategy.
                            </p>
                        </div>

                        <div className="feature-card">
                            <h4>Timing & Demand Peak</h4>
                            <p>
                                Our <strong>Demand Peak</strong> tool helps you determine whether you’re early, late, or just right—so you can align investment with market readiness instead of hope.
                            </p>
                        </div>

                        <div className="feature-card ">
                            {/* <div className="feature-card feature-card-highlight"> */}
                            <h4>Go / No-Go Engine</h4>
                            <p>
                                Behind the scenes, Paybacck’s interpretation engine combines all scores into a <strong>simple, executive-friendly recommendation:</strong> go, pivot, delay, or no-go—plus why, and what to fix.
                            </p>
                        </div>
                    </div>

                    {/* Closing */}
                    <div className="features-closing">
                        <p>
                            Together, these features turn scattered opinions into a <strong>single, coherent investment view</strong>—so your portfolio and roadmap finally reflect reality, not optimism.
                        </p>
                    </div>
                </div>
            </section>

            {/* Services Section */}

            <section class="services-section" id="services">
                <div class="container">
                    {/* <!-- Header --> */}
                    <div class="services-header">
                        <div class="content_heading">Services</div>
                        <h2 class="subheading">Support that meets you where you are.</h2>
                    </div>

                    {/* <!-- Intro --> */}
                    <div class="services-intro">
                        <p>
                            Every organization is at a different stage in its digital journey. Paybacck offers three complementary service models so you can engage in the way that best fits your urgency, team maturity, and budget.
                        </p>
                    </div>

                    {/* <!-- Services --> */}
                    <div class="services-grid">
                        {/* <!-- Consulting --> */}
                        <div class="service-card">
                            <h3>Consulting <span class="service-tag">When decisions can’t wait</span></h3>
                            <p>
                                For urgent, high-stakes situations—large bets, board-level scrutiny, or turnaround scenarios—our consulting team works side-by-side with your leaders to:
                            </p>
                            <ul>
                                <li>Evaluate current or planned digital initiatives using the full Paybacck framework</li>
                                <li>Identify unpromising investments for cost-cutting</li>
                                <li>Highlight pivot paths for struggling products</li>
                                <li>Recommend a prioritized, evidence-backed roadmap</li>
                            </ul>
                            <p class="service-output">
                                You get clear outputs: initiative-level scorecards, executive summaries, and specific recommendations you can act on immediately.
                            </p>
                        </div>

                        {/* <!-- Corporate Training --> */}
                        <div class="service-card">
                            <h3>Corporate Training <span class="service-tag">Build an internal decision muscle</span></h3>
                            <p>
                                For organizations that want sustainable change, we offer <strong>multi-day training and workshops</strong> based on the original  curriculum: core concepts, 16 tools, pivot frameworks, digital transformation mapping, data use-case discovery, and transformative marketing.
                            </p>
                            <p>Your teams learn how to:</p>
                            <ul>
                                <li>Apply Paybacck tools to real initiatives</li>
                                <li>Interpret scores and recommendations</li>
                                <li>Integrate Paybacck into portfolio management and funding processes</li>
                                <li>Use the framework to align business, product, and technology stakeholders</li>
                            </ul>
                            <p class="service-output">
                                The result: a shared language for digital decisions across the enterprise.
                            </p>
                        </div>

                        {/* <!-- Self-Service --> */}
                        <div class="service-card">
                            <h3>Self-Service <span class="service-tag">Start today, go at your own pace</span></h3>
                            <p>
                                If you prefer to move fast and learn as you go, Paybacck’s self-service model gives you:

                            </p>
                            <ul>
                                <li>Online scorecards and guided workflows</li>
                                <li>Video tutorials and use-case walkthroughs</li>
                                <li>Templates for stakeholder workshops and research</li>
                            </ul>
                            <p class="service-output">
                                You can evaluate your first initiatives within days, not months—and scale up later with training or consulting as needed.
                            </p>
                        </div>
                    </div>

                    {/* <!-- Closing --> */}
                    <div class="services-closing">
                        <p>
                            No matter which path you choose, our aim is the same: <strong>help you stop wasting money on the wrong initiatives and double-down on the right ones.</strong>
                        </p>
                    </div>
                </div>
            </section>


            {/*** pricing **/}

            <section class="pricing-section" id="pricing">
                <div class="container">
                    {/* <!-- Header --> */}
                    <div class="pricing-header">
                        <div class="content_heading">Pricing</div>
                        <h2 class="subheading">Designed to fit the way you invest.</h2>
                    </div>

                    {/* <!-- Intro --> */}
                    <div class="pricing-intro">
                        <p>
                            Digital investments come in all sizes—from a founder validating their first idea to an enterprise managing a portfolio of hundreds of initiatives. Paybacck’s pricing philosophy is simple: <strong>you should get a clear payback on the platform that protects your payback.</strong>
                        </p>
                        <p>
                            Instead of one rigid model, we offer tiered options you can adapt as your usage grows.
                        </p>
                    </div>

                    {/* <!-- Pricing Tiers --> */}
                    <div class="pricing-grid">
                        {/* <!-- Starter --> */}
                        <div class="pricing-card">
                            <h3>Starter <span class="tier-tag">Validate your first big bet</span></h3>
                            <p>Ideal for founders, small teams, or a single business unit evaluating a handful of initiatives.</p>
                            <p>Typical inclusions:</p>
                            <ul>
                                <li>Access to core decision tools and scorecards</li>
                                <li>Evaluation of a limited number of initiatives per year</li>
                                <li>Foundational training materials and video tutorials</li>
                                <li>Email support   </li>
                            </ul>
                            <p class="pricing-output">
                                Use this tier to build your first evidence-based investment cases and learn the Paybacck way of thinking.
                            </p>
                        </div>

                        {/* <!-- Growth --> */}
                        <div class="pricing-card">
                            <h3>Growth <span class="tier-tag">Portfolio-level clarity</span></h3>
                            <p>Built for organizations managing multiple products, programs, or transformations across departments.</p>
                            <p>Typical inclusions:</p>
                            <ul>
                                <li>Expanded initiative capacity and additional workspaces</li>
                                <li>Shared dashboards for leadership teams</li>
                                <li>Live onboarding workshop or remote training</li>
                                <li>Priority support and strategy check-ins</li>
                            </ul>
                            <p class="pricing-output">
                                This tier turns Paybacck into your portfolio decision cockpit, where you compare initiatives side-by-side and align funding with true potential.
                            </p>
                        </div>

                        {/* <!-- Enterprise --> */}
                        <div class="pricing-card ">
                        {/* <div class="pricing-card pricing-card-highlight"> */}
                            <h3>Enterprise <span class="tier-tag">Embedded decision framework</span></h3>
                            <p>For large, complex organizations that want Paybacck woven into how they strategize, fund, and execute digital initiatives.</p>
                            <p>Common elements:</p>
                            <ul>
                                <li>Unlimited or high-volume initiative evaluations</li>
                                <li>Single Sign-On (SSO) and advanced user management</li>
                                <li>Custom integrations and API usage</li>
                                <li>On-site or bespoke training programs</li>
                                <li>Executive advisory and co-designed governance processes</li>
                            </ul>
                            <p class="pricing-output">
                                We’ll work with you to tailor a plan that balances <strong>flexibility, capacity, and support</strong>—and tie it back to tangible outcomes such as reduced failed investments, improved time-to-market, and higher innovation ROI.
                            </p>
                        </div>
                    </div>

                    {/* <!-- Closing --> */}
                    <div class="pricing-closing">
                        <p>
                            For detailed pricing and a tailored proposal, <strong>contact us</strong>—we’ll map the plan to the size of your portfolio and your ambitions.
                        </p>
                    </div>
                </div>
            </section>


            {/*** FAQ*** */}

            <section className="faq-section" id="faq">
                <div className="container">
                    {/* Header */}
                    <div className="faq-header">
                        <div className="content_heading">FAQ</div>
                        <p className="faq-subtitle">
                            Questions we hear most often—answered plainly.
                        </p>
                    </div>

                    {/* FAQ List */}
                    <div className="faq-list">
                        <div className="faq-item">
                            <h4 className="faq-question">1. How is Paybacck different from project management or Agile tools?</h4>
                            <p className="faq-answer">
                                Project and Agile tools help you manage <strong>how</strong> work gets done—backlogs, sprints, pipelines, releases. Paybacck helps you decide <strong>what</strong> is worth doing in the first place and <strong>why</strong>. It comes before and alongside delivery tools, not instead of them.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">2. Is Paybacck only for new products and startups?</h4>
                            <p className="faq-answer">
                                No. Paybacck works for <strong>new ideas, existing products, and large transformations.</strong> You can use it to evaluate net-new initiatives, pivot under-performing solutions, or reassess complex portfolios during cost-cutting cycles.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">3. What types of organizations use Paybacck?</h4>
                            <p className="faq-answer">
                                Any organization that makes digital investments: enterprises, mid-market companies, scale-ups, startups, investors, and accelerators. The framework is industry-agnostic and is already applied across sectors from SaaS to retail, logistics, and healthcare.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">4. How long does it take to evaluate an initiative?</h4>
                            <p className="faq-answer">
                                That depends on complexity and how much research has already been done. Many teams get a first pass within days, then refine their inputs over a few weeks as they uncover more customer, market, and financial insights
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">5. Do we need consultants to use Paybacck?</h4>
                            <p className="faq-answer">
                                Not necessarily. You can use the platform self-service with your own teams. Consultants and training simply accelerate adoption, provide outside perspective, and support higher-stakes decisions.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">6. Can Paybacck help us cut costs without killing innovation?</h4>
                            <p className="faq-answer">
                                Yes. One of Paybacck’s strengths is helping you <strong>identify unpromising initiatives for cost-cutting while still protecting high-potential bets</strong>—so you can reduce waste and continue innovating intelligently.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h4 className="faq-question">7. Is Paybacck a one-time exercise or an ongoing process?</h4>
                            <p className="faq-answer">
                                Both. You can use it for one-off decisions, but the real value comes when Paybacck becomes a <strong>continuous gating mechanism</strong>—a shared language for how your organization evaluates, funds, and evolves digital initiatives over time.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/*** careers **/}


            <section className="careers-section" id="careers">
                <div className="container">
                    {/* Header */}
                    <div className="careers-header">
                        <div className="content_heading">Careers</div>
                        <p className="careers-subtitle">
                            Build the future of digital decision-making.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="careers-intro">
                        <p>
                            At Paybacck, we’re not building yet another app. We’re redefining how organizations decide <strong>where their digital dollars go</strong>. If you care about helping companies avoid waste, build smarter products, and unlock meaningful innovation, you’ll feel at home here.
                        </p>
                    </div>

                    {/* Why Work */}
                    <div className="careers-block">
                        <h3>Why Work at Paybacck?</h3>
                        <ul>
                            <li><strong>Real impact.</strong> Our platform gets used in boardrooms, strategy sessions, and product councils—where decisions worth millions (sometimes billions) are made.</li>
                            <li><strong>Deep thinking.</strong> We combine strategy, product, finance, and technology into one framework. You’ll work at the intersection of these worlds, not in a narrow lane.</li>
                            <li><strong>Continuous learning.</strong> Our roots in training and workshops mean we invest heavily in teaching—internally as well as for clients. You’ll learn how leaders across industries think about innovation, risk, and transformation.</li>
                        </ul>
                    </div>

                    {/* Who We Look For */}
                    <div className="careers-block">
                        <h3>Who We Look For</h3>
                        <p>We hire people who are:</p>
                        <ul>
                            <li><strong>Curious problem-solvers</strong> – You like to understand the “why” behind things, not just execute tasks.</li>
                            <li><strong>Comfortable with ambiguity</strong> – Our clients bring messy portfolios and big questions; you enjoy bringing structure to complexity.</li>
                            <li><strong>Collaborative communicators</strong> – ou can navigate conversations with executives, product teams, and engineers alike.</li>
                            <li><strong>Ownership-oriented</strong> – You’re motivated by outcomes, not titles.</li>
                        </ul>
                    </div>

                    {/* Roles */}
                    <div className="careers-block">
                        <h3>Roles You Might Find</h3>
                        <ul>
                            <li>Product strategists & product managers</li>
                            <li>Customer success & implementation specialists</li>
                            <li>Software engineers & data engineers</li>
                            <li>Business analysts & research specialists</li>
                            <li>Marketing & content strategists focused on digital innovation</li>
                        </ul>
                        <p>
                            We embrace flexible work, value diverse perspectives, and care more about your <strong>ability to think and contribute</strong> than about a perfectly linear resume.
                        </p>
                        <p className="bold-lines" >Don’t see a role that fits?</p>
                        <p>
                            Reach out anyway. Tell us how you’d help organizations make better digital bets, and we’ll take it from there.
                        </p>
                    </div>
                </div>
            </section>

            {/*** press **/}

            <section className="press-section" id="press">
                <div className="container">
                    {/* Header */}
                    <div className="press-header">
                        <div className="content_heading">Press</div>
                        <p className="press-subtitle">
                            Covering Paybacck? Here’s our story.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="press-intro">
                        <p>
                            Paybacck is a decision intelligence platform that helps organizations <strong>gate digital investments before they consume years of time and capital.</strong>
                        </p>
                        <p>
                            We provide a structured suite of 16 tools and scorecards that evaluate the “why” and “what” of digital initiatives—problem, customer, revenue, competition, risk, funding, marketing, and timing—resulting in clear <strong>go / no-go recommendations</strong> and actionable guidance.
                        </p>
                    </div>

                    {/* Key Angles */}
                    <div className="press-block">
                        <h3>Key Angles</h3>
                        <ul>
                            <li>
                                <strong>The cost of failed digital initiatives:</strong> Corporate US loses hundreds of billions annually on failed digital solutions and transformations. Paybacck addresses this systemic issue by providing a formal gating framework before execution.
                            </li>
                            <li>
                                <strong>From consulting framework to SaaS platform:</strong> A training- and workshop-driven methodology, the platform has evolved into Paybacck—a scalable SaaS solution plus advisory services.
                            </li>
                            <li>
                                <strong>A new category: digital investment gating:</strong> Rather than competing with Agile or project management tools, Paybacck sits <strong>upstream</strong>, where funding decisions are made and portfolios are shaped.
                            </li>
                        </ul>
                    </div>

                    {/* What We Provide to Media */}
                    <div className="press-block">
                        <h3>What We Provide to Media</h3>
                        <ul>
                            <li>Executive interviews and commentary on:</li>
                            <ul>
                                <li>Digital transformation failures and lessons</li>
                                <li>Innovation portfolio strategy</li>
                                <li>Product-market fit, timing, and risk</li>
                            </ul>
                            <li>Case study examples (anonymized where necessary)</li>
                            <li>Data and narratives drawn from applying the framework to both successful and failed digital products</li>
                        </ul>
                        <p>
                            For press inquiries, speaking requests, and media kits, please contact: <a href="mailto:press@paybacck.com"><strong>press@paybacck.com</strong></a>
                        </p>
                        <p>
                            We’re happy to collaborate on stories at the intersection of <strong>innovation, governance, risk, and digital strategy.</strong>
                        </p>
                    </div>
                </div>
            </section>

            {/*** events **/}

            <section className="events-section" id="events">
                <div className="container">
                    {/* Header */}
                    <div className="events-header">
                        <div className="content_heading">Events</div>
                        <p className="events-subtitle">
                            Learn, practice, and connect.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="events-intro">
                        <p>
                            Paybacck Events bring our frameworks to life in collaborative settings where leaders can <strong>learn, apply, and challenge</strong>    how they make digital decisions.
                        </p>
                    </div>

                    {/* What We Run */}
                    <div className="events-block">
                        <h3>What We Run</h3>
                        <ul>
                            <li>
                                <strong>Executive Briefings & Board Sessions</strong><br />
                                Focused, 60–90 minute sessions for senior leadership on the economics of digital failure, the role of investment gating, and how Paybacck can be woven into governance.
                            </li>
                            <li>
                                <strong>Hands-On Workshops</strong><br />
                                Half-day or multi-day interactive sessions where teams apply Paybacck tools to real initiatives—building scorecards, interpreting results, and defining next actions.
                            </li>
                            <li>
                                <strong>Public Webinars & Virtual Clinics</strong><br />
                                Open sessions that walk through specific tools (e.g., Buyer Motivation Parity, Demand Peak, Solution Scorecard) and invite participant questions.
                            </li>
                            <li>
                                <strong>Conference Talks & Panels</strong><br />
                                Keynotes and panels on digital transformation, innovation portfolios, and decision frameworks.
                            </li>
                        </ul>
                    </div>

                    {/* Why Attend */}
                    <div className="events-block">
                        <h3>Why Attend?</h3>
                        <ul>
                            <li>Practice using Paybacck tools with expert guidance</li>
                            <li>See how other organizations structure their digital decision processes</li>
                            <li>Surface blind spots in your own portfolio</li>
                            <li>Bring back templates and techniques you can reuse with your team</li>
                        </ul>
                        <p>
                            Upcoming events and registration details are listed on this page throughout the year.
                        </p>
                        <p>
                            If you’d like to host a private event or invite a Paybacck speaker to your conference, reach out via our <strong>Contact</strong> page.
                        </p>
                    </div>
                </div>
            </section>

            {/*** partnerships **/}

            <section className="partnerships-section" id="partnerships">
                <div className="container">
                    {/* Header */}
                    <div className="partnerships-header">
                        <div className="content_heading">Partnerships</div>
                        <p className="partnerships-subtitle">
                            Multiply impact through partnership.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="partnerships-intro">
                        <p>
                            Paybacck’s mission—to help organizations make better digital bets—is bigger than any single company. That’s why we actively partner with firms that shape digital strategy, execution, and funding.
                        </p>
                    </div>

                    {/* Who We Partner With */}
                    <div className="partnerships-block">
                        <h3>Who We Partner With</h3>
                        <ul>
                            <li>
                                <strong>Consulting & Advisory Firms</strong><br />
                                Strategy, digital, and innovation consultancies that want a structured framework to evaluate client initiatives and support board-level decisions.
                            </li>
                            <li>
                                <strong>Systems Integrators & Delivery Partners</strong><br />
                                Implementation partners who want to ensure they are building the right things for clients, not just delivering scope.
                            </li>
                            <li>
                                <strong>Venture Capital & Private Equity Firms</strong><br />
                                Investors looking for a disciplined way to assess portfolio companies, new deals, and digital transformation within their holdings.
                            </li>
                            <li>
                                <strong>Accelerators & Innovation Labs</strong><br />
                                Programs that nurture startups or internal ventures and want to improve their graduation and success rates.
                            </li>
                        </ul>
                    </div>

                    {/* What Partners Gain */}
                    <div className="partnerships-block">
                        <h3>What Partners Gain</h3>
                        <ul>
                            <li>Access to Paybacck tools and training for their teams</li>
                            <li>Co-branded offerings that combine their expertise with our framework</li>
                            <li>Priority support and roadmap input</li>
                            <li>Joint case studies, events, and thought leadership</li>
                        </ul>
                        <p>
                            If you’re helping organizations innovate, transform, or invest—and you want a <strong>repeatable, evidence-based framework</strong> to strengthen your work—we’d love to talk.
                        </p>
                        <p>
                            Use the <strong>Contact</strong> page and select “Partnerships” as your topic.
                        </p>
                    </div>
                </div>
            </section>

            {/*** knowledge **/}

            <section className="knowledge-section" id="knowledge-base">
                <div className="container">
                    {/* Header */}
                    <div className="knowledge-header">
                        <div className="content_heading">Knowledge Base</div>
                        <p className="knowledge-subtitle">
                            All the “how-to” knowledge, one searchable library.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="knowledge-intro">
                        <p>
                            The Paybacck Knowledge Base is your self-service reference for everything from <strong>core concepts</strong> to <strong>advanced usage patterns.</strong>
                        </p>
                        <p>
                            Content is organized into clear sections:
                        </p>
                    </div>

                    {/* Sections */}
                    <div className="knowledge-block">
                        <ul>
                            <li>
                                <strong>Getting Started</strong> – Workspace setup, user roles, terminology, and first-time workflows
                            </li>
                            <li>
                                <strong>Tools & Scorecards</strong> – Article series for each of the 16 tools, explaining concepts like Problem Scorecard, Buyer Motivation Parity, Risk Score, Revenue Score, Crux Rectangle, PMCM, and Demand Peak. Each article is grounded in the same principles as training. 
                            </li>
                            <li>
                                <strong>Use Cases & Playbooks</strong> – How to apply Paybacck to startups, enterprise transformations, portfolio pruning, product pivots, M&A tech evaluation, and more
                            </li>
                            <li>
                                <strong>Governance & Process Integration</strong> – Guidance on embedding Paybacck into investment committees, steering groups, and funding cycles
                            </li>
                            <li>
                                <strong>Troubleshooting & FAQs</strong> – Quick answers to common configuration and usage questions
                            </li>
                        </ul>
                    </div>

                    {/* Goals */}
                    <div className="knowledge-block">
                        <h3>We write Knowledge Base content with three goals:</h3>
                        <ul>
                            <li><strong>Clarity</strong> – Plain language explanations with diagrams and examples</li>
                            <li><strong>Actionability</strong> – Checklists, templates, and workshop formats you can use immediately</li>
                            <li><strong>Depth</strong> – Enough detail that experienced leaders and practitioners feel respected, not talked down to</li>
                        </ul>
                        <p>
                            Before submitting a support ticket, check the Knowledge Base—there’s a good chance someone else has already faced (and solved) the same challenge.
                        </p>
                    </div>
                </div>
            </section>

            {/*** video tutorials **/}


            <section className="videos-section" id="video-tutorials">
                <div className="container">
                    {/* Header */}
                    <div className="videos-header">
                        <div className="content_heading">Video Tutorials</div>
                        <p className="videos-subtitle">
                            Learn by watching. Apply by doing.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="videos-intro">
                        <p>
                            Our Video Tutorials library turns Paybacck from a framework on paper into something you can see and feel in action.
                        </p>
                        <p>
                            Each video is short, focused, and designed to be watched right before you apply what you’ve learned. You’ll find:
                        </p>
                    </div>

                    {/* Video Types */}
                    <div className="videos-block">
                        <ul>
                            <li>
                                <strong>Tool deep-dives</strong> – 5–10 minute videos walking through a single tool (e.g., Solution Scorecard, Buyer Motivation Parity, Risk Score) using a realistic example
                            </li>
                            <li>
                                <strong>End-to-end walkthroughs</strong> – Longer sessions showing how to evaluate a full initiative from problem definition to final recommendation
                            </li>
                            <li>
                                <strong>Role-based guides</strong> – Videos tailored for executives, product managers, portfolio owners, and analysts
                            </li>
                            <li>
                                <strong>Workshop recordings</strong> – Anonymized clips from real or simulated sessions so you can see how conversations unfold in practice
                            </li>
                        </ul>
                    </div>

                    {/* Benefits */}
                    <div className="videos-block">
                        <h3>Why Video Tutorials?</h3>
                        <ul>
                            <li>Prepare for internal workshops or executive reviews</li>
                            <li>Onboard new team members quickly</li>
                            <li>Refresh how a specific tool works before using it in a high-stakes context</li>
                        </ul>
                        <p>
                            You can watch tutorials directly inside the application or from the Resources section of the site. Pair them with the Knowledge Base and you’ll have both <strong>conceptual understanding and practical guidance</strong> at your fingertips.
                        </p>
                    </div>
                </div>
            </section>


            {/*** case studies **/}

            <section className="case-studies-section" id="case-studies">
                <div className="container">
                    {/* Header */}
                    <div className="case-studies-header">
                        <div className="content_heading">Case Studies</div>
                        <p className="case-studies-subtitle">
                            From theory to measurable impact.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="case-studies-intro">
                        <p>
                            The Case Studies section showcases how organizations use Paybacck to <strong>save money, focus efforts, and unlock growth.</strong>
                        </p>
                        <p>
                            Each case study walks through:
                        </p>
                    </div>

                    {/* Structure */}
                    <div className="case-studies-block">
                        <ul>
                            <li><strong>The situation</strong> – Market context, business goals, and the digital portfolio or initiative under pressure</li>
                            <li><strong>The challenge</strong> – Symptoms like low adoption, unclear ROI, roadmap sprawl, or conflicting stakeholder opinions</li>
                            <li><strong>The Paybacck approach</strong> – Which tools and scorecards were used, how workshops were run, and how data was gathered</li>
                            <li><strong>The decision</strong> – Go / no-go or pivot outcomes, plus rationale</li>
                            <li><strong>The results</strong> – Cost avoided, initiatives reshaped, or revenue and adoption gains over time</li>
                        </ul>
                    </div>

                    {/* Examples */}
                    <div className="case-studies-block">
                        <h3>Some examples you might see:</h3>
                        <ul>
                            <li>
                                A mature enterprise using Paybacck to identify and cut <strong>unpromising initiatives</strong> while still funding high-potential innovations during a cost-reduction program.
                            </li>
                            <li>
                                A scale-up that used Paybacck’s buyer, problem, and competitive tools to pivot a struggling product into a strong market fit.
                            </li>
                            <li>
                                An investor applying the framework to analyze potential portfolio companies and avoid deals with hidden structural weaknesses.
                            </li>
                        </ul>
                        <p>
                            All examples are anonymized or shared with permission, but the structure is real: <strong>messy challenges, clear decisions, tangible outcomes.</strong>
                        </p>
                        <p>
                            If you’re considering Paybacck, the Case Studies page is the best place to see how the framework behaves in the wild—not just in theory.
                        </p>
                    </div>
                </div>
            </section>

            {/*** white papers **/}


            <section className="whitepapers-section" id="white-papers">
                <div className="container">
                    {/* Header */}
                    <div className="whitepapers-header">
                        <div className="content_heading">White Papers</div>
                        <p className="whitepapers-subtitle">
                            Deep thinking for high-stakes decisions.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="whitepapers-intro">
                        <p>
                            Our White Papers are for leaders who want to go beyond tips and tactics into the <strong>structural economics and psychology of digital investment.</strong>
                        </p>
                        <p>
                            Topics include, for example:
                        </p>
                    </div>

                    {/* Topics */}
                    <div className="whitepapers-block">
                        <ul>
                            <li>
                                <strong>The Real Cost of Failed Digital Initiatives</strong> – Analyzing why digital solutions and transformations fail at such high rates, and how a formal gating framework can reduce that waste. 
                            </li>
                            <li>
                                <strong>Managing the Why and What of Digital Investments</strong> – Explaining why focusing only on the “how” (delivery) creates fragile foundations, and how Paybacck’s approach closes that gap.
                            </li>
                            <li>
                                <strong>From Siloed Insights to Integrated Decisions</strong> – Showing how isolated research, finance, and product analyses can be connected into a single, executable view.
                            </li>
                            <li>
                                <strong>Digital Transformation Without the Burnout</strong> – Using investment gating to reduce wasted effort, improve employee retention, and protect work-life balance.
                            </li>
                        </ul>
                    </div>

                    {/* Approach */}
                    <div className="whitepapers-block">
                        <h3>Each White Paper Is:</h3>
                        <ul>
                            <li>Research-backed</li>
                            <li>Rich with frameworks, diagrams, and practical examples</li>
                            <li>Designed to be shared with boards, investment committees, and leadership teams</li>
                        </ul>
                        <p>
                            If you’re tasked with <strong>making the case for disciplined digital decision-making</strong> inside your organization, our white papers will give you the language, logic, and evidence to do it.
                        </p>
                    </div>
                </div>
            </section>


            {/*** tutorials **/}

            <section className="tutorials-section" id="tutorials">
                <div className="container">
                    {/* Header */}
                    <div className="tutorials-header">
                        <div className="content_heading">Tutorials</div>
                        <p className="tutorials-subtitle">
                            Hands-on guides for doing, not just understanding.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="tutorials-intro">
                        <p>
                            While Video Tutorials focus on watching, our written Tutorials are designed for <strong>doing</strong>. Each tutorial walks you through a specific outcome, such as:
                        </p>
                        <ul>
                            <li>Running your first initiative evaluation end-to-end</li>
                            <li>Facilitating a cross-functional workshop on problem definition</li>
                            <li>Using Paybacck to compare multiple ideas and pick a winner</li>
                            <li>Preparing an executive summary and investment memo from Paybacck outputs</li>
                        </ul>
                    </div>

                    {/* Tutorial Details */}
                    <div className="tutorials-block">
                        <h3>Tutorials Include:</h3>
                        <ul>
                            <li><strong>Prerequisites</strong> – what data, people, and time you’ll need</li>
                            <li><strong>Step-by-step instructions</strong> – clicks in the platform, questions to ask your team, and prompts to use in meetings</li>
                            <li><strong>Templates & examples</strong> – sample slides, emails, and documents</li>
                            <li><strong>Common pitfalls</strong> – what typically goes wrong and how to avoid it</li>
                        </ul>
                        <p>
                           Think of Tutorials as <strong>guided rehearsals</strong>. Follow them once, and you’ll know how to do it alone next time.
                        </p>
                    </div>
                </div>
            </section>

            {/*** security features **/}

            <section className="security-section" id="security-features">
                <div className="container">
                    {/* Header */}
                    <div className="security-header">
                        <div className="content_heading">Security Features</div>
                        <p className="security-subtitle">
                            Protecting your decisions and your data.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="security-intro">
                        <p>
                            The initiatives you evaluate in Paybacck are often <strong>strategic and sensitive</strong>—future products, acquisitions, transformations, and competitive responses. We treat that responsibility seriously.
                        </p>
                        <p>
                            Key aspects of our security approach include:
                        </p>
                    </div>

                    {/* Security Features List */}
                    <div className="security-block">
                        <ul>
                            <li><strong>Secure data handling</strong> – All data is encrypted in transit and at rest using industry-standard protocols.</li>
                            <li><strong>Access control</strong> – Role-based permissions ensure users only see the workspaces, initiatives, and insights relevant to them.</li>
                            <li><strong>Workspace isolation</strong> – Separate environments for different business units or client organizations (for partners) help reduce risk and maintain clean boundaries.</li>
                            <li><strong>Auditability</strong> – Activity logging allows you to track who created, edited, or approved evaluations and when.</li>
                            <li><strong>Identity integration</strong> – Support for single sign-on via common identity providers so you can manage access centrally.</li>
                        </ul>
                        <p>
                            We regularly review our security posture, update practices, and align with industry expectations for enterprise-grade SaaS. For more detailed information or security questionnaires, please contact our team—we’ll gladly collaborate with your security and compliance stakeholders.
                        </p>
                    </div>
                </div>
            </section>

            {/*** deepdive **/}

            <section className="deepdive-section" id="deepdive">
                <div className="container">
                    {/* Header */}
                    <div className="deepdive-header">
                        <div className="content_heading">Paybacck DeepDive™ – Detailed Investment Evaluation</div>
                        <p className="deepdive-subtitle">
                            For the digital bets that will define your future.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="deepdive-intro">
                        <p>
                            Paybacck DeepDive™ is your <strong>full-spectrum evaluation service</strong> for high-stakes digital investments—major product launches, platform rebuilds, multi-year transformations, or strategic technology programs. DeepDive™ applies the complete Paybacck decision framework to answer one critical question with precision: <strong>Should we really do this, and if so, under what conditions?</strong>
                        </p>
                        <p>
                            In most organizations, the true outcome of a big digital bet is discovered <strong>two to three years after funding,</strong> when the market has already ruled and the budget is gone. By that time, the cost of a bad decision shows up as wasted capital, lost time, missed opportunities, and exhausted teams. Research shows that 70–90% of digital initiatives and startups fail or fall short of expectations—a staggering drag on growth. 
                        </p>
                        <p>
                            DeepDive™ compresses those years of uncertainty into <strong>weeks of disciplined analysis,</strong> giving leaders a defendable decision before committing fully.
                        </p>
                    </div>

                    {/* What DeepDive Examines */}
                    <div className="deepdive-block">
                        <h3>What DeepDive™ Examines</h3>
                        <p>DeepDive™ walks through every major driver of digital success:</p>
                        <ul>
                            <li><strong>Problem strength & validation</strong> – Is this a real, urgent, valuable problem for clearly defined customers, or just a nice-to-have idea?</li>
                            <li><strong>Buyer motivation & decision dynamics</strong> – Who must say “yes,” what motivates them, and are those motivations strong enough to drive adoption and purchasing behavior?</li>
                            <li><strong>Solution viability & differentiation</strong> – Can your organization realistically build and support this solution, and does it stand out in a way the market will recognize?</li>
                            <li><strong>Revenue, risk & funding</strong> – What is the plausible revenue or value trajectory? Where are the commercial, operational, and strategic risks? Is the initiative funded to succeed, not just to start?</li>
                            <li><strong>Competitive & market context</strong> – How crowded is the space, where are you truly differentiated, and how could incumbents or new entrants respond?</li>
                            <li><strong>Execution & team readiness</strong> – Do you have the skills, partners, and operating model necessary for launch, scaling, and continuous improvement?</li>
                        </ul>
                        <p>
                            Each dimension is scored using structured evaluation tools and targeted research prompts. Paybacck’s interpretation engine then integrates the results into a clear <strong>go / hold / pivot / no-go</strong> recommendation, highlighting strengths, weaknesses, and hidden deal-killers.
                        </p>
                    </div>

                    {/* What You Receive */}
                    <div className="deepdive-block">
                        <h3>What You Receive</h3>
                        <ul>
                            <li>A detailed <strong>Investment Evaluation Report</strong> with scores, analysis, and scenario insights</li>
                            <li>A concise <strong>Executive Decision Brief</strong> suitable for boards and investment committees</li>
                            <li>A set of <strong>concrete pivots, design changes, and sequencing options</strong> that significantly improve your odds of success</li>
                            <li>Optional <strong>roadmap and prioritization guidance</strong>, connecting this initiative to your broader digital portfolio</li>
                        </ul>
                    </div>

                    {/* Who DeepDive Serves */}
                    <div className="deepdive-block">
                        <h3>Who DeepDive™ Serves</h3>
                        <ul>
                            <li>Executive teams evaluating major digital programs or transformations</li>
                            <li>Product organizations preparing to enter new categories or markets</li>
                            <li>Investors and boards assessing large digital bets, acquisitions, or turnarounds</li>
                        </ul>
                        <p>
                            If an initiative will consume meaningful capital, leadership attention, and organizational energy, Paybacck DeepDive™ ensures the decision is grounded in <strong>evidence and structure—not optimism, politics, or inertia.</strong>
                        </p>
                    </div>
                </div>
            </section>


            {/*** quickscan **/}


            <section className="quickscan-section" id="quickscan">
                <div className="container">
                    {/* Header */}
                    <div className="quickscan-header">
                        <div className="content_heading">Paybacck QuickScan™ – Quick Idea Evaluation</div>
                        <p className="quickscan-subtitle">
                            Turn idea overflow into a focused, high-signal pipeline.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="quickscan-intro">
                        <p>
                            Paybacck QuickScan™ is the <strong>fast, lightweight evaluation service</strong> for early-stage ideas, internal pitches, and “what if…?” concepts that constantly emerge in modern organizations. Rather than pushing every idea into business-case limbo, QuickScan™ helps you decide—in days—whether it deserves deeper investment, needs reshaping, or should gracefully exit your pipeline.
                        </p>
                        <p>
                            Digital portfolios don’t only suffer from big failed projects; they also suffer when <strong>too many low-potential ideas soak up attention and debate.</strong> QuickScan™ creates a disciplined, transparent “front door” for innovation so every idea is treated fairly, quickly, and consistently.
                        </p>
                    </div>

                    {/* What QuickScan Looks At */}
                    <div className="quickscan-block">
                        <h3>What QuickScan™ Looks At</h3>
                        <ul>
                            <li><strong>Rapid problem framing</strong> – Is the problem concrete and meaningful, or just fuzzy aspiration dressed as strategy?</li>
                            <li><strong>Snapshot of buyer motivation</strong> – Who would truly care about this, and is their pain or desire intense enough to drive action?</li>
                            <li><strong>First-pass solution fit</strong> – Does the proposed solution plausibly align with the problem, environment, and constraints, or is there an obvious mismatch?</li>
                            <li><strong>Simple value logic</strong> – Is there a believable path to value—through revenue, cost savings, risk reduction, or strategic leverage?</li>
                            <li><strong>Timing & competition glance</strong> – Is the idea obviously too late, too early, or lost in a sea of similar offerings?</li>
                        </ul>
                        <p>
                            The output is a concise <strong>Idea Evaluation Snapshot</strong> with a traffic-light verdict: <strong>Promising, Promising with Rework, or Unlikely to Pay Back.</strong>
                        </p>
                    </div>

                    {/* How Teams Use QuickScan */}
                    <div className="quickscan-block">
                        <h3>How Teams Use QuickScan™</h3>
                        <ul>
                            <li>Idea intake & hackathons – Screen dozens or hundreds of ideas and quickly elevate the ones that truly stand out.</li>
                            <li>Roadmap and backlog triage – Challenge long-sitting items whose rationale has become vague or outdated.</li>
                            <li>Innovation councils & steering groups – Give decision makers a shared language to discuss ideas without demanding full-blown business cases for everything.</li>
                        </ul>
                    </div>

                    {/* Benefits */}
                    <div className="quickscan-block">
                        <h3>Benefits of QuickScan™</h3>
                        <ul>
                            <li><strong>Speed</strong> – Move from raw idea to structured verdict in days, not months.</li>
                            <li><strong>Consistency</strong> – Apply the same criteria across departments and personalities; enthusiasm still matters, but structure leads.</li>
                            <li><strong>Focus</strong> – Protect leaders’ time and organizational energy by sending only high-signal ideas into deeper discovery or Paybacck DeepDive™.</li>
                        </ul>
                        <p>
                            QuickScan™ is not about saying “no” more often; it’s about saying <strong>“yes” more confidently and intentionally</strong> by ensuring early-stage ideas are screened with rigor and fairness before they consume your most precious resources.
                        </p>
                    </div>
                </div>
            </section>

            {/*** costcraft **/}

            <section className="costcraft-section" id="costcraft">
                <div className="container">
                    {/* Header */}
                    <div className="costcraft-header">
                        <div className="content_heading">Paybacck CostCraft™ – Detailed Cost Builder for Projects</div>
                        <p className="costcraft-subtitle">
                            From rough guesses to clear, defensible investment plans.
                        </p>
                    </div>

                    {/* Intro */}
                    <div className="costcraft-intro">
                        <p>
                            Paybacck CostCraft™ is a <strong>structured cost-building and funding-alignment service</strong> for digital initiatives of any size—from focused product enhancements to multi-year transformation programs. It turns high-level concepts and rough estimates into a transparent, data-driven picture of what an initiative will realistically take to deliver and sustain.
                        </p>
                        <p>
                            Many digital projects struggle not because the idea is wrong, but because <strong>funding, scope, and expectations are misaligned from the very start.</strong> Budgets are set around arbitrary targets or optimistic assumptions, only for reality to surface later as overruns, rushed compromises, or silent cancellations. CostCraft™ is designed to eliminate that pattern.
                        </p>
                    </div>

                    {/* How CostCraft Works */}
                    <div className="costcraft-block">
                        <h3>How CostCraft™ Works</h3>
                        <ul>
                            <li><strong>Scope decomposition</strong> – We break down your initiative into clear workstreams—product features, platform components, transformation phases, markets, or business units—so costs can be tied to meaningful slices of value.</li>
                            <li><strong>Phasing & lifecycle mapping</strong> – Using proven lifecycle and roadmap principles, CostCraft sequences work into phases that align with value milestones, risk reduction, and learning goals—not just calendar quarters.</li>
                            <li><strong>Cost modeling across dimensions</strong> – For each workstream and phase, we model costs for people, technology, vendors, change management, ongoing operations, and contingency. Assumptions are explicit, challengeable, and documented.</li>
                            <li><strong>Risk-aware scenarios</strong> – Instead of a single brittle budget, CostCraft creates scenarios that show best-case, expected, and risk-adjusted views, helping leaders understand where uncertainty is highest and which levers matter most.</li>
                            <li><strong>Funding wave design</strong> – We align funding releases with clear decision gates, value checkpoints, and measurable outcomes so capital is deployed in smarter increments instead of one irreversible lump sum.</li>
                        </ul>
                    </div>

                    {/* Deliverables */}
                    <div className="costcraft-block">
                        <h3>Deliverables You Receive</h3>
                        <ul>
                            <li>A comprehensive <strong>CostCraft Blueprint</strong> detailing scope, assumptions, cost breakdowns, and scenarios</li>
                            <li>A <strong>Funding & Milestone Map</strong> showing how investment ties to phases, outcomes, and governance points</li>
                            <li>A concise <strong>Executive Cost Brief</strong> for steering committees, CFOs, and boards</li>
                        </ul>
                    </div>

                    {/* When to Use */}
                    <div className="costcraft-block">
                        <h3>When to Use CostCraft™</h3>
                        <ul>
                            <li>Before requesting major funding approval for a new product or platform</li>
                            <li>When re-baselining an existing program that has drifted from its original budget</li>
                            <li>During portfolio planning cycles where initiatives are competing for finite capital</li>
                        </ul>
                        <p>
                            With Paybacck CostCraft™, funding decisions are no longer about who can argue loudest or present the rosiest slide. They’re anchored in a <strong>clear, honest, and strategically aligned view of what it will truly take to deliver.</strong>
                        </p>
                    </div>
                </div>
            </section>



        </div>

    );
};

export default NewHome;
